(function () {
  function initMznav2() {
    var nav = document.getElementById("mznav2");
    if (!nav) return;

    var mobileToggle = nav.querySelector(".mznav2-mobile-toggle");
    var mobileIcon = nav.querySelector(".mznav2-mobile-icon");
    var items = nav.querySelectorAll(".mz2-item");

    /* -----------------------------
       floating / sticky controller
    ----------------------------- */
    var placeholder = document.createElement("div");
    placeholder.className = "mznav2-placeholder";

    if (
      !nav.nextElementSibling ||
      !nav.nextElementSibling.classList ||
      !nav.nextElementSibling.classList.contains("mznav2-placeholder")
    ) {
      nav.parentNode.insertBefore(placeholder, nav.nextSibling);
    } else {
      placeholder = nav.nextElementSibling;
    }

    function getStickyOffset() {
      return window.innerWidth <= 767 ? 0 : 0;
    }

    function setPlaceholderHeight() {
      placeholder.style.height = nav.offsetHeight + "px";
    }

    function getTriggerTop() {
      var rect = nav.getBoundingClientRect();
      return window.scrollY + rect.top;
    }

    var triggerTop = 0;

    function refreshTriggerTop() {
      nav.classList.remove("is-floating");
      placeholder.classList.remove("is-active");
      setPlaceholderHeight();
      triggerTop = getTriggerTop();
      handleFloating();
    }

    function handleFloating() {
      var offset = getStickyOffset();
      setPlaceholderHeight();

      if (window.scrollY > triggerTop - offset) {
        nav.classList.add("is-floating");
        placeholder.classList.add("is-active");
      } else {
        nav.classList.remove("is-floating");
        placeholder.classList.remove("is-active");
      }
    }

    /* -----------------------------
       desktop top-level switching
    ----------------------------- */
    function blurNavFocus() {
      var focused = document.activeElement;
      if (focused && nav.contains(focused)) {
        focused.blur();
      }
    }

    function closeAllTopItems() {
      items.forEach(function (i) {
        i.classList.remove("is-open");
      });
    }

    function resetAllDrillStates() {
      nav.querySelectorAll(".mz2-multi.is-drill").forEach(function (multi) {
        multi.classList.remove("is-drill");
      });
    }

    function openTopItem(item) {
      items.forEach(function (i) {
        i.classList.toggle("is-open", i === item);
      });

      items.forEach(function (i) {
        if (i !== item) {
          var btn = i.querySelector(".mz2-top");
          if (btn && document.activeElement === btn) {
            btn.blur();
          }
        }
      });
    }

    /* -----------------------------
       mobile toggle
    ----------------------------- */
    if (mobileToggle) {
      mobileToggle.addEventListener("click", function () {
        var open = nav.classList.contains("mob-open");
        nav.classList.toggle("mob-open", !open);
        mobileToggle.setAttribute("aria-expanded", !open ? "true" : "false");

        if (mobileIcon) {
          mobileIcon.textContent = !open ? "−" : "+";
        }

        if (open) {
          closeAllTopItems();
          resetAllDrillStates();
        }
      });
    }

    /* -----------------------------
       top-level open/close
    ----------------------------- */
    items.forEach(function (item) {
      var top = item.querySelector(".mz2-top");
      if (!top) return;

      top.addEventListener("click", function (e) {
        if (window.innerWidth <= 767) {
          e.preventDefault();
          var open = item.classList.contains("is-open");

          closeAllTopItems();
          resetAllDrillStates();

          if (!open) {
            item.classList.add("is-open");
          }
        } else {
          e.preventDefault();
          openTopItem(item);

          setTimeout(function () {
            top.blur();
          }, 0);
        }
      });

      item.addEventListener("mouseenter", function () {
        if (window.innerWidth > 767) {
          openTopItem(item);
        }
      });
    });

    nav.addEventListener("mouseleave", function () {
      if (window.innerWidth > 767) {
        closeAllTopItems();
        blurNavFocus();
      }
    });

    /* -----------------------------
       search
    ----------------------------- */
      /* -----------------------------
       global predictive search
    ----------------------------- */
    var predictiveCache = new Map();

    function debounce(fn, wait) {
      var timer = null;
      return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      };
    }

    function escapeHtml(str) {
      return (str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function formatMoneyFromCents(cents) {
      if (typeof cents !== "number") return "";
      return "$" + (cents / 100).toFixed(2);
    }

    function getSearchUi(scope) {
      return {
        container: scope.querySelector(".mz2-global-search"),
        productsWrap: scope.querySelector(".mz2-global-products"),
        productsList: scope.querySelector(".mz2-global-products-list"),
        collectionsWrap: scope.querySelector(".mz2-global-collections"),
        collectionsList: scope.querySelector(".mz2-global-collections-list"),
        queriesWrap: scope.querySelector(".mz2-global-queries"),
        queriesList: scope.querySelector(".mz2-global-queries-list"),
        empty: scope.querySelector(".mz2-global-empty")
      };
    }

    function clearSearchResults(scope) {
      if (!scope) return;

      var ui = getSearchUi(scope);
      scope.classList.remove("mz2-searching");

      if (ui.container) ui.container.hidden = true;
      if (ui.productsWrap) ui.productsWrap.hidden = true;
      if (ui.collectionsWrap) ui.collectionsWrap.hidden = true;
      if (ui.queriesWrap) ui.queriesWrap.hidden = true;
      if (ui.empty) ui.empty.hidden = true;

      if (ui.productsList) ui.productsList.innerHTML = "";
      if (ui.collectionsList) ui.collectionsList.innerHTML = "";
      if (ui.queriesList) ui.queriesList.innerHTML = "";
    }

    function renderPredictiveResults(scope, data, keyword) {
      var ui = getSearchUi(scope);
      if (!ui.container) return;

      var predictive = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = predictive.products || [];
      var collections = predictive.collections || [];
      var queries = predictive.queries || [];

      if (ui.productsList) ui.productsList.innerHTML = "";
      if (ui.collectionsList) ui.collectionsList.innerHTML = "";
      if (ui.queriesList) ui.queriesList.innerHTML = "";

      if (ui.productsWrap) ui.productsWrap.hidden = products.length === 0;
      if (ui.collectionsWrap) ui.collectionsWrap.hidden = collections.length === 0;
      if (ui.queriesWrap) ui.queriesWrap.hidden = queries.length === 0;

      products.forEach(function (product) {
        var price = "";
        if (product.price && typeof product.price.min !== "undefined") {
          price = formatMoneyFromCents(product.price.min);
        } else if (typeof product.price === "number") {
          price = formatMoneyFromCents(product.price);
        }

        var imageUrl = "";
        if (product.image) {
          imageUrl = product.image;
        } else if (product.featured_image && product.featured_image.url) {
          imageUrl = product.featured_image.url;
        }

        var html =
          '<a class="mz2-product-result" href="' + product.url + '">' +
            '<span class="mz2-product-thumb">' +
              (imageUrl ? '<img src="' + imageUrl + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : "") +
            '</span>' +
            '<span class="mz2-product-meta">' +
              '<span class="mz2-product-title">' + escapeHtml(product.title) + '</span>' +
              (price ? '<span class="mz2-product-price">' + escapeHtml(price) + '</span>' : "") +
            '</span>' +
          '</a>';

        if (ui.productsList) {
          ui.productsList.insertAdjacentHTML("beforeend", html);
        }
      });

      collections.forEach(function (collection) {
        var html =
          '<a class="mz2-global-link" href="' + collection.url + '">' +
            escapeHtml(collection.title) +
          '</a>';

        if (ui.collectionsList) {
          ui.collectionsList.insertAdjacentHTML("beforeend", html);
        }
      });

      queries.forEach(function (queryItem) {
        var suggestionText = queryItem.text || queryItem.styled_text || keyword;
        var searchUrl = window.Shopify.routes.root + "search?q=" + encodeURIComponent(suggestionText);

        var html =
          '<a class="mz2-global-link" href="' + searchUrl + '">' +
            escapeHtml(suggestionText) +
          '</a>';

        if (ui.queriesList) {
          ui.queriesList.insertAdjacentHTML("beforeend", html);
        }
      });

      var hasAny = products.length || collections.length || queries.length;

      scope.classList.add("mz2-searching");
      ui.container.hidden = false;
      if (ui.empty) ui.empty.hidden = !!hasAny;

      if (!hasAny && ui.empty) {
        ui.empty.hidden = false;
      }
    }

    function fetchPredictiveSearch(keyword) {
      var q = (keyword || "").trim();
      if (!q) return Promise.resolve(null);

      if (predictiveCache.has(q)) {
        return Promise.resolve(predictiveCache.get(q));
      }

      var url =
        window.Shopify.routes.root +
        "search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection,query" +
        "&resources[limit]=8" +
        "&resources[options][unavailable_products]=hide";

      return fetch(url, {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Predictive search request failed");
          return res.json();
        })
        .then(function (json) {
          predictiveCache.set(q, json);
          return json;
        });
    }

    function runPredictiveSearch(scope, keyword) {
      var raw = (keyword || "").trim();
      var box = scope.querySelector(".mz2-search-box");
      var clearBtn = scope.querySelector(".mz2-search-clear");

      if (box) {
        box.classList.toggle("has-value", raw.length > 0);
      }

      if (clearBtn) {
        clearBtn.style.display = raw.length > 0 ? "block" : "none";
      }

      if (!raw) {
        clearSearchResults(scope);
        return;
      }

      fetchPredictiveSearch(raw)
        .then(function (data) {
          renderPredictiveResults(scope, data, raw);
        })
        .catch(function () {
          clearSearchResults(scope);
        });
    }

    var debouncedPredictiveSearch = debounce(function (scope, keyword) {
      runPredictiveSearch(scope, keyword);
    }, 180);

    /* -----------------------------
       side group switch
    ----------------------------- */
    function setupGroup(groupName) {
      var sideBtns = nav.querySelectorAll('.mz2-sidebtn[data-group="' + groupName + '"]');
      var panels = nav.querySelectorAll('.mz2-panel[data-group="' + groupName + '"]');

      function getGroupInner() {
        if (!sideBtns.length) return null;
        return sideBtns[0].closest(".mz2-inner");
      }

      function getGroupMulti() {
        if (!sideBtns.length) return null;
        return sideBtns[0].closest(".mz2-multi");
      }

      function getGroupTitleEl() {
        var inner = getGroupInner();
        return inner ? inner.querySelector(".mz2-mobile-title") : null;
      }

      function activate(id, btnText) {
        sideBtns.forEach(function (btn) {
          btn.classList.toggle("on", btn.getAttribute("data-target") === id);
        });

        panels.forEach(function (panel) {
          panel.classList.toggle("on", panel.getAttribute("data-id") === id);
        });

        var anyActive = false;
        panels.forEach(function (panel) {
          if (panel.classList.contains("on")) {
            anyActive = true;
          }
        });

        if (!anyActive && panels.length > 0) {
          panels[0].classList.add("on");
        }

        var titleEl = getGroupTitleEl();
        if (titleEl && btnText) {
          titleEl.textContent = btnText;
        }

      var activePanel = nav.querySelector('.mz2-panel[data-group="' + groupName + '"].on');
if (activePanel) {
  var inner = activePanel.closest(".mz2-inner");
  var input = inner ? inner.querySelector(".mz2-search-input") : null;

  if (input && inner) {
    if (input.value.trim()) {
      debouncedPredictiveSearch(inner, input.value);
    } else {
      clearSearchResults(inner);
    }
  }
}
      }

      sideBtns.forEach(function (btn) {
        btn.addEventListener("mouseenter", function () {
          if (window.innerWidth > 767) {
            activate(btn.getAttribute("data-target"), btn.textContent.trim());
          }
        });

        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          var target = btn.getAttribute("data-target");
          var btnText = btn.textContent.trim();

          activate(target, btnText);

          if (window.innerWidth <= 767) {
            var multi = getGroupMulti();
            if (multi) {
              multi.classList.add("is-drill");
            }

            var activePanel = nav.querySelector('.mz2-panel[data-group="' + groupName + '"].on');
            if (activePanel) {
              var modelScroll = activePanel.querySelector(".mz2-modelscroll");
              if (modelScroll) {
                modelScroll.scrollTop = 0;
              }
            }
          }
        });
      });

      var inner = getGroupInner();
      if (inner) {
        var backBtn = inner.querySelector(".mz2-mobile-back");
        if (backBtn) {
          backBtn.addEventListener("click", function () {
            var multi = getGroupMulti();
            if (multi) {
              multi.classList.remove("is-drill");
            }
          });
        }
      }

      if (sideBtns.length && panels.length) {
        var activeBtn = null;
        sideBtns.forEach(function (btn) {
          if (btn.classList.contains("on")) {
            activeBtn = btn;
          }
        });

        if (!activeBtn) {
          activeBtn = sideBtns[0];
        }

        if (activeBtn) {
          activate(activeBtn.getAttribute("data-target"), activeBtn.textContent.trim());
        }
      }
    }

    nav.querySelectorAll(".mz2-inner").forEach(function (inner) {
      var input = inner.querySelector(".mz2-search-input");
      var clear = inner.querySelector(".mz2-search-clear");

      if (input) {
      if (input) {
        input.addEventListener("input", function () {
          debouncedPredictiveSearch(inner, input.value);
        });
      }
      }

     if (clear) {
  clear.addEventListener("click", function () {
    if (input) {
      input.value = "";
      clearSearchResults(inner);
      input.focus();
    }
  });
}
    });

    setupGroup("apple");
    setupGroup("samsung");
    setupGroup("motorola");
    setupGroup("google");
    setupGroup("other");

    document.addEventListener("click", function (e) {
      if (window.innerWidth <= 767 && !nav.contains(e.target)) {
        closeAllTopItems();
        resetAllDrillStates();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 767) {
        closeAllTopItems();
        blurNavFocus();
        resetAllDrillStates();
      }
      refreshTriggerTop();
    });

    window.addEventListener("scroll", handleFloating, { passive: true });
    window.addEventListener("load", refreshTriggerTop);

    setTimeout(refreshTriggerTop, 50);
    setTimeout(refreshTriggerTop, 300);
    setTimeout(refreshTriggerTop, 800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMznav2);
  } else {
    initMznav2();
  }
})();